import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Profile.css";

const Profile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const ADMIN_EMAIL = "admin@gmail.com";
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/SignIn");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/");
  };

  const handleGoToDashboard = () => {
    if (!user) {
      navigate("/SignIn");
      return;
    }

    // 🔐 Role-based navigation
    if (user.email === ADMIN_EMAIL) {
      navigate("/admin-dashboard");
    } else {
      navigate("/dashboard");
    }
  };


  if (!user) return null;

  const fullName = user.name || "";
  const firstName = fullName.split(" ")[0] || fullName;
  const initials = fullName
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase())
    .slice(0, 2)
    .join("");

  return (
    <div className="xc-profile-page">
      <div className="xc-profile-card">
        <div className="xc-profile-card-top">
          <span className="xc-profile-pill">Profile</span>
        </div>

        <div className="xc-profile-header">
          <div className="xc-profile-avatar">{initials || "U"}</div>
          <div className="xc-profile-heading">
            <h2 className="xc-profile-title">Welcome, {firstName} 👋</h2>
            <p className="xc-profile-subtitle">
              You&apos;re signed in to your XenaChat workspace.
            </p>
          </div>
        </div>

        <div className="xc-profile-details">
          <div className="xc-profile-detail">
            <span className="xc-profile-detail-label">Full name</span>
            <span className="xc-profile-detail-value">
              {fullName || "—"}
            </span>
          </div>

          <div className="xc-profile-detail">
            <span className="xc-profile-detail-label">Email</span>
            <span className="xc-profile-detail-value">
              {user.email || "—"}
            </span>
          </div>

          {user.planName && (
            <div className="xc-profile-detail">
              <span className="xc-profile-detail-label">Current plan</span>
              <span className="xc-profile-detail-value xc-profile-plan-badge">
                {user.planName}
              </span>
            </div>
          )}
        </div>

        <div className="xc-profile-actions">
          <button
            className="xc-profile-btn xc-profile-btn--ghost"
            onClick={handleGoToDashboard}
          >
            Dashboard
          </button>
          <button
            className="xc-profile-btn xc-profile-btn--primary"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;